import React from 'react';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalFooter, Button } from '@chakra-ui/react';
import { noop } from "../../utils";
export var DeleteCreditCardModal = function DeleteCreditCardModal(props) {
  var _a = props.onConfirm,
      onConfirm = _a === void 0 ? noop : _a,
      disclosure = props.disclosure;
  var isOpen = disclosure.isOpen,
      onClose = disclosure.onClose;
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onClose: onClose,
    blockScrollOnMount: false,
    isCentered: true
  }, /*#__PURE__*/React.createElement(ModalOverlay, null), /*#__PURE__*/React.createElement(ModalContent, null, /*#__PURE__*/React.createElement(ModalHeader, null, "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E1A\u0E31\u0E15\u0E23\u0E40\u0E14\u0E23\u0E14\u0E34\u0E15 / \u0E40\u0E14\u0E1A\u0E34\u0E15"), /*#__PURE__*/React.createElement(ModalCloseButton, null), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    mr: 3,
    variant: "outline",
    size: "lg"
  }, "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01"), /*#__PURE__*/React.createElement(Button, {
    colorScheme: "red",
    size: "lg",
    onClick: function onClick() {
      onConfirm();
      onClose();
    }
  }, "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19"))));
};